export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapRampMeters';
export const ENTITY_EDIT_ROUTE = 'ramp-meter/details';
